import { Oval, ThreeDots } from "react-loader-spinner";

export const ThreeDotLoader = ({ visible, color }) => {
  return (
    <ThreeDots
      visible={true}
      height="100%"
      width="13%"
      color={color}
      radius="9"
      ariaLabel="three-dots-loading"
      wrapperStyle={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      wrapperClass=""
    />
  );
};

export const OvalLoader = ({ color }) => {
  return (
    <Oval
      visible={true}
      height="13%"
      width="13%"
      color={color || "#3366CC"}
      secondaryColor="#3366CC90"
      ariaLabel="oval-loading"
      wrapperStyle={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      wrapperClass=""
    />
  );
};
